import React from "react";
import { motion } from "framer-motion";

import AboutMeHero from "./AboutMeHero/AboutMeHero";
import Skills from "./skills/Skills";

const AboutMe = () => (
  <motion.div
      initial={
          {
              opacity: 0,
          }
      }
      animate={
          {
              opacity: 1,
          }
      }
      exit={
          {
              opacity: 0,
          }
      }
    >
    <AboutMeHero />
    <Skills />
  </motion.div>
);

export default AboutMe;
